module.exports = __webpack_public_path__ + "static/AvenirNext-Bold-1a8a42013dba515d552dc35848d28fa0.woff";